module.exports = __webpack_public_path__ + "static/media/vous_etes_bien2.743da66b.mp3";